import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { environment } from '../../../environments/environment';

import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { OnDemandClassesService } from '../services/on-demand-classes.service';
import { OnDemandEquipmentAssetObject } from '../services/on-demand-classes.service.model';

interface IAssetChecked {
  assetId: string;
  checked: boolean;
  facilityId: string | undefined;
  hasUserPermission?: boolean;
}

interface IproductInfodataList {
  checked: boolean;
  activityId?: string;
  assetList: IAssetChecked[];
  expanded: boolean;
  facilityId: string;
}

@Component({
  selector: 'app-product-info-grid',
  templateUrl: './product-info-grid.component.html',
  styleUrls: ['./product-info-grid.component.css'],
})
export class ProductInfoGridComponent implements OnInit, OnChanges {
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;
  selectAllEquipment = { checked: false };
  assetListData: { checked: any }[][];
  @Input() productInfoHeaderList: [{ columnName: string }];
  @Input() productInfoDataList: IproductInfodataList[];
  @Input() statusCountList: object;
  @Input() confirmationCountList: object;
  @Input() userPermission: boolean;
  @Input() isCollapsible: boolean;
  @Input() multipleFacilities: boolean;
  @Input() isNewDesign:boolean;
  @Input() skipEligibleCheck:boolean;
  @Output() assetListValues: EventEmitter<object> = new EventEmitter();
  constructor(private rootScopeService: RootScopeService, private router: Router,  private facilityService: FacilityService,
    private onDemandClassesService: OnDemandClassesService, public commonUtil: CommonUtil) {
    this.getRootScopeData();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.selectAllEquipment.checked = false;
    this.assetListValues.emit([]);
  }

  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  selectDeselectAllAssets(values: { currentTarget: { checked: boolean } }): void {
    this.productInfoDataList = this.productInfoDataList.map((x: IproductInfodataList) => {
      x.checked = values.currentTarget.checked; // for setting Select All checkbox value for each equipment Type
      x.assetList = x.assetList
        .map((a: IAssetChecked) => {
            a.checked = a.hasUserPermission ? values.currentTarget.checked : false; // for setting  checkbox value for each asset 
            return a;
        });
      return x;
    });         
    this.populateAssetList();
  }

  selectDeselectAssetsByActivityId(assetList: object[], values: { currentTarget: { checked: boolean } }): void {
    assetList = assetList.map((x: IAssetChecked) => {
      x.checked = x.hasUserPermission ? values.currentTarget.checked : false; // for setting  checkbox value for each asset under the particular activity Id's assetList
      return x;
    });
    this.selectDeselectSelectAllEquipment();
    this.populateAssetList();
  }  
  selectDeselectSelectAllEquipment(): void {
    let anyUnselectedEquipment = 0;
    anyUnselectedEquipment = this.productInfoDataList.filter(
      (eqListitem: { checked: boolean }) => !eqListitem.checked
    ).length;
    if (anyUnselectedEquipment > 0) {
      this.selectAllEquipment.checked = false;
    } else {
      this.selectAllEquipment.checked = true;
    }
  }

  selectDeselectSelectAllByAsset(asset: { activityId: string; assetId: string; checked: boolean; facilityId: string }): void {
    let anyUnselectedEquipmentForActivityId = 0;
    let equipmentListByActivityId;
    equipmentListByActivityId = this.productInfoDataList.filter((x) => x.activityId === asset.activityId);
    // tslint:disable-next-line: no-shadowed-variable
    this.assetListData = equipmentListByActivityId.map((asset: IproductInfodataList) => asset.assetList);
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < this.assetListData[0].length; i++) {
      if (typeof this.assetListData[0][i].checked === 'undefined' || !this.assetListData[0][i].checked) {
        anyUnselectedEquipmentForActivityId = anyUnselectedEquipmentForActivityId + 1;
      }
    }
    if (anyUnselectedEquipmentForActivityId > 0) {
      equipmentListByActivityId.map((equipmentItem: { checked: boolean }) => (equipmentItem.checked = false));
    } else {
      equipmentListByActivityId.map((equipmentItem: { checked: boolean }) => (equipmentItem.checked = true));
    }
    this.selectDeselectSelectAllEquipment();
    this.populateAssetList();
  }

  populateAssetList(): void {
    let selectedAssets = this.productInfoDataList
      .map(p => p.assetList.filter(a => a.checked))
      .reduce((p, c) => p.concat(c));
    if(this.multipleFacilities) {
      this.assetListValues.emit(selectedAssets);
    } else {
      this.assetListValues.emit(selectedAssets.map(s => s.assetId));
    }  
  }

  navigateRemoteUpdate(assetChecked: IAssetChecked): void {
    const facilityId = assetChecked.facilityId;
    if(facilityId !== undefined && this.facilityService.selectedFacility().facilityId !== facilityId) {
      this.facilityService.selectFacility(facilityId, true);
    }
    this.router.navigate(['/software/remoteupdate']);
  }

  generateImgSrcUrl(modelId: string, console: string) {
    return this.commonUtil.imgSrcGenerate(modelId, console);
  }
}
